<wms-dialog-body>
<div class="dialog-header">
  <button class="btn-transparent btn pull-right close" type="button"  (click)="closeDialog()">
    <i class="wi wi-close"></i>
  </button>
</div>
<div class="details-container">
  <div class="logo-container">
    <img alt="Brand Logo" [src]="user.enterpriseLogoUrl" *ngIf="user.enterpriseLogoUrl"/>
    <span class="wms-icon wms-about-logo" *ngIf="!user.enterpriseLogoUrl"></span>
  </div>
  <p name="wm-build-details" class="build-details">
    {{product.type}} {{locale['LABEL_RELEASE']}} ({{product.release }})
    <span name="wm-build-version">
              <a href="{{product.changeLogLink}}" target="_blank"> {{platformVer}} </a>
            </span>
  </p>
  <p name="wm-build-releasedate">{{locale['LABEL_RELEASED']}}: {{releaseDate | date : 'dd MMMM yyyy HH:mm:ss Z'}}</p>
  <p name="wm-build-releasedate">{{locale['LABEL_STUDIO_UI_VERSION']}}: {{studioUIVersion}}</p>
  <p name="wm-build-releasedate">{{locale['LABEL_APP_RUNTIME_UI_VERSION']}}: {{appRuntimeUIVersion}}</p>
  <p name="wm-build-releasedate">{{locale['LABEL_APP_RUNTIME_SERVICES_VERSION']}}: {{appRuntimeServicesVersion}}</p>
  <p name="wm-copyrights" class="copyright" [innerHTML]="studioInfo.copyright"></p>
</div>
</wms-dialog-body>
